<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. قسم التحكم والبحث (يختفي عند الطباعة) -->
    <div class="card mb-4 no-print">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">تسجيل ومتابعة غياب الطلاب</h5>
      </div>
      
      <div class="card-body">
        <!-- صف الاختيارات -->
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">الفصل الدراسي</label>
             <select
          @change="getSubjectswithtearm(form.term)"
          v-model="form.term"
          class="form-control" 
        >
          <option value="">اختر الفصل الدراسي</option>
          <option v-for="t in terms" :key="t.id" :value="t">
            {{ t.name }}
          </option>
        </select>
          </div>

          <div class="col-md-6">
            <label class="form-label fw-bold">المادة</label>
            <select v-model="form.subject" class="form-control">
          <option value="">اختر المادة</option>
          <option v-for="s in subjects" :key="s.id" :value="s">
            {{ s.name }}
          </option>
        </select>
          </div>
<!-- 
          <div class="col-md-4">
            <label class="form-label fw-bold">المجموعة</label>
            <select v-model="form.group" class="form-control">
              <option value="">اختر المجموعة</option>
              <option v-for="g in groups" :key="g.id" :value="g.id">
                {{ g.group_name }}
              </option>
            </select>
          </div> -->
          
          <!-- صف رقم الجلوس -->
          <div class="col-md-12 mt-3">
            <label class="form-label fw-bold">رقم الجلوس</label>
            <div class="input-group">
              <span class="input-group-text bg-light">#</span>
              <input 
                v-model="form.Seating_No" 
                type="number" 
                class="form-control form-control-lg" 
                placeholder="أدخل رقم جلوس الطالب هنا..."
                @keyup.enter="SaveAbsStudent" 
              />
            </div>
          </div>
        </div>

        <!-- الأزرار -->
        <div class="d-flex justify-content-end mt-4 flex-wrap gap-2">
          <button @click="SaveAbsStudent" class="btn btn-primary mx-1 mb-2">
            <i class="fas fa-save"></i> حفظ الغياب
          </button>
          
          <button @click="SaveAbsStudentKh" class="btn btn-danger mx-1 mb-2">
            <i class="fas fa-user-secret"></i> حفظ كـ ورقة خاصة (سرية)
          </button>
          
          <button @click="getStudentWithAbs" class="btn btn-warning text-dark mx-1 mb-2">
            <i class="fas fa-search"></i> استعلام عن الغياب
          </button>
          
          <button @click="print" class="btn btn-info text-white mx-1 mb-2">
            <i class="fas fa-print"></i> طباعة الاستعلام
          </button>
        </div>
      </div>
    </div>

    <!-- رسائل التنبيه -->
    <div v-if="message" class="alert alert-success alert-dismissible fade show mt-3 no-print" role="alert">
      {{ message }}
      <button type="button" class="btn-close" @click="message = ''"></button>
    </div>

  <div v-if="Object.keys(absStudent).length > 0" class="print-area" id="printMe">
    
    <!-- حلقة تكرار لكل عضو كنترول -->
    <div v-for="(groups, memberName) in absStudent" :key="memberName" class="control-member-section mb-5" style="page-break-after: always;">
      
      <!-- ترويسة العضو (تظهر مرة واحدة لكل عضو) -->
      <div class="member-header bg-dark text-white p-2 mb-3 rounded text-center ">
        <h5 class="m-0">عضو الكنترول: {{ memberName }}</h5>
      </div>

      <!-- حلقة تكرار لكل مجموعة تابعة لهذا العضو -->
      <div v-for="(students, groupNo) in groups" :key="groupNo" class="group-table-wrapper mb-4" style="page-break-inside: avoid;">
        
        <!-- ترويسة الجدول (المطلوبة) -->
        <div class="table-header-custom border border-bottom-0 p-2 text-center bg-light">
            <div class="row fw-bold">
                <div class="col-4 text-end">عضو الكنترول: {{ memberName }}</div>
                <div class="col-4">المادة: {{ form.subject.name }}</div> <!-- تأكد من الاسم -->
                <div class="col-4 text-start">مجموعة رقم: {{ groupNo }}</div>
            </div>
        </div>

        <!-- جدول الطلاب لهذه المجموعة -->
        <div class="table-responsive">
          <table class="table table-bordered table-sm text-center mb-0">
            <thead class="table-secondary">
              <tr>
                <th style="width: 15%"> سري</th>
                <th style="width: 15%">رقم الجلوس</th>
                <th  style="width: 40%">اسم الطالب</th>
                <th style="width: 15%">حالة القيد</th>
                <th style="width: 20%">ملاحظات</th>
                <th style="width: 10%" class="no-print">حذف</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="student in students" :key="student.id">
                <td class="fw-bold">{{ student.SecretKey_1 }}</td> <!-- تأكد من اسم العمود -->
                <td class="fw-bold">{{ student.Seating_No_1 }}</td> <!-- تأكد من اسم العمود -->
                <td class="text-start pe-3">{{ student.Arabic_Name }}</td>
                <td>{{ student.status || 'نظامي' }}</td>
                <td>غائب</td>
                <td class="no-print">
                   <button 
                     class="btn btn-outline-danger btn-sm py-0" 
                     @click="deleteAbsStudent(student.group_no, form.subject, student.Seating_No_1, form.term)"
                   > 
                     &times;
                   </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
      </div> <!-- نهاية المجموعة -->
      
      <!-- فاصل صفحات بعد كل عضو (اختياري) -->
      <div class="page-break"></div>

    </div> <!-- نهاية العضو -->

    <!-- تذييل عام -->
    <div class="report-footer mt-4 text-start text-muted fs-6">
      * تم استخراج هذا التقرير بتاريخ: {{ new Date().toLocaleDateString('ar-EG') }}
    </div>

  </div>
  </div>
</template>









<script>
import api from "../../api/axios";
export default {
  data() {
    return {
      message: "",
      subjects: [],
      terms: [],
      groups: [],
      // absStudent: [],
 absStudent: {},
      form: {
        Seating_No: "",
        subject: "",
        term: "",
        group: "",
      },
    };
  },

  mounted() {
    api.get("/getterms").then((res) => {
      this.terms = res.data;
    });

    api.get("/getgroupsAllUser").then((res) => {
      this.groups = res.data;
    });
  },

  methods: {
    getSubjectswithtearm(id) {
    
      api.get("/getSubject/" + id.id).then((res) => {
        this.subjects = res.data;
        // this.getStudentWithAbs();
      });
    },
   SaveAbsStudent() {
    this.message = null;

    // تحقق بسيط قبل الإرسال
    if (!this.form.Seating_No || !this.form.subject || !this.form.term) {
        this.message = "يرجى اختيار الترم، المادة، وكتابة رقم الجلوس";
        return;
    }

    api
    .post("savedataabsstudenAll", this.form)
    .then((res) => {
        this.message = res.data.message;
        
        // تفريغ خانة رقم الجلوس فقط لتسهيل إدخال الطالب التالي بسرعة
        this.form.Seating_No = ""; 
        
        // تركيز المؤشر مرة أخرى على حقل الإدخال (اختياري، يحتاج ref="seatInput")
        this.$refs.seatInput.focus();

        // تحديث الجدول (اختياري: قد يحتاج تعديل لأن الجدول يعتمد على المجموعة)
        if(this.form.group) { 
            this.getStudentWithAbs(); 
        }
    })
    .catch((e) => {
        if (e.response && e.response.status === 404) {
            this.message = e.response.data.message;
        } else if (e.response && e.response.data.message) {
             this.message = e.response.data.message;
        } else {
            // this.message = "حدث خطأ غير متوقع";
            console.log("Error:", e);
        }
    });
},
    SaveAbsStudentKh() {
        this.message = null
      api
        .post("save-data-abs-studen-kh", this.form)
        .then((res) => {
          this.message = res.data.message;
          //   this.form.sitting_number = "";
          this.getStudentWithAbs();
        })
        .catch((e) => {
              if (e.response && e.response.status === 404) {
       this.message =  e.response.data.message;
    } else {
        console.log("Other Error:", e);
    }
        });
    },
    deleteAbsStudent(group , subject , Seating_No , term) {
      console.log(group , subject , Seating_No , term);
      
      api
        .post("deleteAbsStudent", {
            subject: subject,
            term: term,
            Seating_No: Seating_No,
            group: group,
        })
        .then((res) => {
          this.id = res.data;
          this.getStudentWithAbs();
        })
        .catch(() => {
          console.log("error Save");
        });
    },
      getGroupName(groupId) {
        // البحث في مصفوفة المجموعات المحملة مسبقاً
        const group = this.groups.find(g => g.id == groupId);
        return group ? group.group_name : groupId;
    },
   getStudentWithAbs() {
      // لا ننفذ الطلب إلا إذا تم اختيار الترم والمادة
      if(!this.form.term || !this.form.subject) return;

      api
        .post("/getStudentWithAbsAll", {
            term: this.form.term,
            subject: this.form.subject,
            // نرسل البيانات الأساسية فقط، ولا نرسل group لكي لا يفلتر الباك اند عليها
            // (إلا إذا كنت عدلت الباك اند ليتجاهلها كما في الخطوة 1)
        })
        .then((res) => {
          this.absStudent = res.data;
        })
        .catch((e) => {
            console.log(e);
        });
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe", () => {
        console.log("Printing done or got cancelled!");
      });
    },
  },
};
</script>

<style scoped>
.container {
  direction: rtl;
  text-align: right;
}

.report-container {
  width: 100%;
  padding: 20px;
  font-family: "Cairo", sans-serif;
  color: #222;
}

.report-header {
  text-align: center;
  margin-bottom: 25px;
}

.report-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}

.report-header .sub {
  font-size: 14px;
  color: #555;
}

.table-report {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 15px;
}

.table-report thead {
  background: #f1f1f1;
}

.table-report th {
  padding: 10px 8px;
  text-align: center;
  border: 1px solid #ccc;
  font-weight: 700;
}

.table-report td {
  padding: 9px 6px;
  border: 1px solid #ddd;
  text-align: center;
}

.table-report tbody tr:nth-child(even) {
  background: #fafafa;
}

.table-report tbody tr:hover {
  background: #eef5ff;
}

.footer-note {
  margin-top: 30px;
  text-align: left;
  font-size: 13px;
  color: #777;
}


.table-header-custom {
    border: 1px solid #dee2e6;
    background-color: #f8f9fa;
    font-size: 1.1rem;
}

@media print {
    .no-print { display: none !important; }
    .d-print-none { display: none !important; }
    
    /* ضمان عدم قص الجدول في المنتصف */
    .group-table-wrapper {
        page-break-inside: avoid;
        margin-bottom: 20px;
    }
    
    /* بداية صفحة جديدة لكل عضو كنترول */
    .page-break {
        page-break-after: always;
    }
    
    /* إظهار الحدود والألوان */
    .table-header-custom {
        border: 1px solid #000 !important;
        background-color: #eee !important;
        -webkit-print-color-adjust: exact;
    }
    table, th, td {
        border: 1px solid #000 !important;
    }
}
</style>